/* tslint:disable:no-console */

import { Debugger } from '@fnv-core/debugging';
import { ILogger, LogLevel } from '../interfaces';

export class ConsoleLogger implements ILogger {
  log(message: any, logLevel: LogLevel) {
    if (!Debugger.isEnabled()) {
      return;
    }

    switch (logLevel) {
      case 'debug':
        console.debug(message);
        break;
      case 'info':
        console.info(message);
        break;
      case 'error':
        console.error(message);
        break;
    }
  }
}
